export default "__VITE_ASSET__BAoHj_NN__"